import React from 'react'
import type { PortableTextBlock } from '@portabletext/react'

import { RichText } from './RichText'

import './Header.scss'

type HeaderProps = {
  eyebrow: string
  title: string
  description?: PortableTextBlock[]
}

export const Header: React.FC<HeaderProps> = ({
  eyebrow,
  title,
  description,
}) => {
  return (
    <header className="flexible-program-header">
      <div className="flexible-program-header__eyebrow type-eyebrow">
        {eyebrow}
      </div>
      <h3 className="flexible-program-header__title">{title}</h3>
      {description && (
        <div className="flexible-program-header__description">
          <RichText content={description} />
        </div>
      )}
    </header>
  )
}
